import {MobileDevicesState} from './states/mobile-devices.state';
import {MobileEventsState} from './states/mobile-events.state';
import {MobileNavState} from './states/mobile-nav.state';

export const mobileDevicesStates = [
    MobileDevicesState,
    MobileNavState,
    MobileEventsState
];
